<template>
    <div>
        <v-row class="mt-2">
            <v-col xl="10" md="12" sm="12" class="ml-5">
                <div>
                    <div>
                        <h1 style="font-weight: 300" class="pb-1">Briefing Settings</h1>
                    </div>

                    <div class="pa-5 pt-0">
                        <v-checkbox label="use default settings" v-model="useDefault"></v-checkbox>

                        <!-- Targeted length -->
                        <v-row class="qgreycard">
                            <v-col>
                                <div class="lbl pb-2">
                                    TARGETED LENGTH OF CONTENT
                                    <v-tooltip max-width="450" color="" top open-on-focus>
                                        <template v-slot:activator="{ on, attrs }">
                                            <button v-bind="attrs" v-on="on" type="button" class="pl-0 mr-auto tooltipicon" aria-label="Help: targeted length of content">
                                                <v-icon small aria-hidden="true">mdi-help-circle-outline</v-icon>
                                            </button>
                                        </template>
                                        <span id="tip-length">
                                            This field allows you to specify the desired length of the content for your project. The default value is based on the average length of competitors’
                                            content. Consider attention span, topic complexity, and detail level.
                                        </span>
                                    </v-tooltip>
                                </div>

                                <v-text-field
                                    :disabled="useDefault"
                                    @focus="showTipp('title')"
                                    rounded
                                    filled
                                    type="number"
                                    inputmode="numeric"
                                    min="0"
                                    step="50"
                                    v-model.number="project.settings.word_count"
                                    label="Target word count"
                                    :hint="'avg. competitors content length: ' + Math.ceil(project.avgWordCount)"
                                    persistent-hint
                                    :aria-describedby="'tip-length'" />
                            </v-col>
                        </v-row>

                        <!-- Targeted term usage -->
                        <v-row class="qgreycard">
                            <v-col>
                                <div class="lbl pb-2">
                                    TARGETED TERM USAGE
                                    <v-tooltip max-width="450" color="" top open-on-focus>
                                        <template v-slot:activator="{ on, attrs }">
                                            <button v-bind="attrs" v-on="on" type="button" class="pl-0 mr-auto tooltipicon" aria-label="Help: targeted term usage">
                                                <v-icon small aria-hidden="true">mdi-help-circle-outline</v-icon>
                                            </button>
                                        </template>
                                        <span id="tip-terms">
                                            Specify how frequently selected phrases should appear. Example: 75% of selected phrases must be used at least as often as competitors on average.
                                        </span>
                                    </v-tooltip>
                                </div>

                                <v-select
                                    :disabled="useDefault"
                                    hint="Default: 75%"
                                    persistent-hint
                                    :items="termusages"
                                    v-model="project.settings.term_usage"
                                    rounded
                                    filled
                                    item-text="text"
                                    item-value="value"
                                    label="Target term usage"
                                    :aria-describedby="'tip-terms'" />
                            </v-col>
                        </v-row>

                        <!-- Targeted readability -->
                        <v-row class="qgreycard">
                            <v-col>
                                <div class="lbl pb-2">
                                    TARGETED READABILITY
                                    <v-tooltip max-width="450" color="" top open-on-focus>
                                        <template v-slot:activator="{ on, attrs }">
                                            <button v-bind="attrs" v-on="on" type="button" class="pl-0 mr-auto tooltipicon" aria-label="Help: targeted readability">
                                                <v-icon small aria-hidden="true">mdi-help-circle-outline</v-icon>
                                            </button>
                                        </template>
                                        <span id="tip-readability"> Set the desired readability level based on the Flesch Reading Ease Index. Easier text can improve engagement and sharing. </span>
                                    </v-tooltip>
                                </div>

                                <v-select
                                    :disabled="useDefault"
                                    hint="Default: normal"
                                    persistent-hint
                                    :items="readabilities"
                                    v-model="project.settings.readability"
                                    rounded
                                    filled
                                    item-text="text"
                                    return-object
                                    label="Target readability (Flesch)"
                                    :aria-describedby="'tip-readability'" />
                            </v-col>
                        </v-row>

                        <!-- Targeted image usage -->
                        <v-row class="qgreycard">
                            <v-col>
                                <div class="lbl pb-2">
                                    TARGETED IMAGE USAGE
                                    <v-tooltip max-width="450" color="" top open-on-focus>
                                        <template v-slot:activator="{ on, attrs }">
                                            <button v-bind="attrs" v-on="on" type="button" class="pl-0 mr-auto tooltipicon" aria-label="Help: targeted image usage">
                                                <v-icon small aria-hidden="true">mdi-help-circle-outline</v-icon>
                                            </button>
                                        </template>
                                        <span id="tip-images">
                                            Specify desired number of images. Default is based on competitors’ average. Relevant, high-quality images enhance content and engagement.
                                        </span>
                                    </v-tooltip>
                                </div>

                                <v-text-field
                                    :disabled="useDefault"
                                    :hint="'avg. competitors image count: ' + project.avgImgCount"
                                    persistent-hint
                                    v-model="project.settings.img_count"
                                    rounded
                                    type="number"
                                    inputmode="numeric"
                                    min="0"
                                    step="1"
                                    filled
                                    label="Target image count"
                                    :aria-describedby="'tip-images'" />
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        props: {
            project: Object
        },
        data() {
            return {
                // readabilities: [
                //     { id: 1, min: 0, max: 30, text: "very difficult", color: "red darken-4" },
                //     { id: 2, min: 30, max: 50, text: "difficult", color: "red darken-2" },
                //     { id: 3, min: 50, max: 60, text: "demanding", color: "orange darken-2" },
                //     { id: 4, min: 60, max: 70, text: "normal", color: "amber darken-2" },
                //     { id: 5, min: 70, max: 80, text: "simple", color: "yellow darken-2" },
                //     { id: 6, min: 80, max: 90, text: "easy", color: "green darken-1" },
                //     { id: 7, min: 90, max: 100, text: "very easy", color: "light-green darken-2" }
                // ],
                readabilities: [
                    { id: 1, min: 0, max: 20, text: "very difficult", color: "red darken-4" },
                    { id: 2, min: 20, max: 40, text: "difficult", color: "red darken-2" },
                    { id: 3, min: 40, max: 45, text: "demanding", color: "orange darken-2" },
                    { id: 4, min: 45, max: 60, text: "normal", color: "amber darken-2" },
                    { id: 5, min: 60, max: 70, text: "simple", color: "yellow darken-2" },
                    { id: 6, min: 70, max: 80, text: "easy", color: "green darken-1" },
                    { id: 7, min: 80, max: 90, text: "very easy", color: "light-green darken-2" }
                ],
                termusages: [
                    { text: "10%", value: 10 },
                    { text: "15%", value: 10 },
                    { text: "20%", value: 10 },
                    { text: "25%", value: 25 },
                    { text: "30%", value: 30 },
                    { text: "35%", value: 35 },
                    { text: "40%", value: 40 },
                    { text: "45%", value: 45 },
                    { text: "50%", value: 50 },
                    { text: "55%", value: 55 },
                    { text: "60%", value: 60 },
                    { text: "65%", value: 65 },
                    { text: "70%", value: 70 },
                    { text: "75%", value: 75 },
                    { text: "80%", value: 80 },
                    { text: "85%", value: 85 },
                    { text: "90%", value: 90 },
                    { text: "95%", value: 95 },
                    { text: "100%", value: 100 }
                ],
                useDefault: true
            }
        },
        methods: {
            showTipp(tippID) {
                if (!this.visibleTipp) {
                    this.visibleTipp = this.tipps.find((tipp) => tipp.id == tippID)
                } else {
                    this.visibleTipp = null
                    setTimeout(() => {
                        this.visibleTipp = this.tipps.find((tipp) => tipp.id == tippID)
                    }, 500)
                }
            }
        },
        mounted() {
            if (this.project.settings.word_count == 0) {
                this.project.settings.word_count = this.project.avgWordCount
            }
        }
    }
</script>

<style>
    .infocard {
        height: 100%;
        background-color: rgb(199, 199, 199);
        border-radius: 15px;
    }
    .lbl {
        font-size: 12px !important;
        font-weight: 600;
    }
    .formarea {
        border-radius: 10px;
        padding: 5px 20px;
        box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
        background: linear-gradient(
            90deg,
            var(--v-background_gradient_1-base) 0%,
            var(--v-background_gradient_2-base) 26%,
            var(--v-background_gradient_3-base) 50%,
            var(--v-background_gradient_4-base) 75%,
            var(--v-background_gradient_5-base) 100%
        );
        /* background: #fafbfa; */
    }
    .tippicon {
        display: flex;
        height: 100%;
    }
    .tipp {
        display: flex;
        height: 100%;
    }
</style>
